import { useTranslation } from 'react-i18next';
import { Badge, type BadgeTone } from '@/components/ui/badge';
import { INTAKE_SUBMISSION_STATUS } from '@/constants/intake';

function resolveIntakeStatusTone(status: string): BadgeTone {
  if (status === INTAKE_SUBMISSION_STATUS.accepted) {
    return 'success';
  }
  if (status === INTAKE_SUBMISSION_STATUS.returned) {
    return 'warning';
  }
  if (status === INTAKE_SUBMISSION_STATUS.submitted) {
    return 'neutral';
  }
  return 'muted';
}

interface IntakeStatusBadgeProps {
  status: string;
}

export function IntakeStatusBadge({ status }: IntakeStatusBadgeProps) {
  const { t } = useTranslation('intake');
  return (
    <Badge tone={resolveIntakeStatusTone(status)} size="sm">
      {t('status.' + status)}
    </Badge>
  );
}
